import { notification } from 'antd';

notification.config({ placement: 'topRight' });

export const notify = notification;
